'use strict';

var Sugar = require('sugar-core');

Sugar.Date.defineInstance({

  'getUTCWeekday': function(date) {
    return date.getUTCDay();
  }

});

module.exports = Sugar.Date.getUTCWeekday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/getUTCWeekday.js
// module id = 190
// module chunks = 1